import {
  HiUserGroup,
  HiSparkles,
  HiBookOpen,
  HiGlobeAlt,
  HiCheck,
} from "react-icons/hi2";

const pillars = [
  {
    id: "personalised",
    title: "Personalised Education",
    Icon: HiUserGroup,
    items: [
      "Subject Selection",
      "Transfer of Credits (TOC)",
      "Subject Split",
      "Balance Academics with Sports/Arts",
    ],
  },
  {
    id: "ai",
    title: "AI Powered Learning",
    Icon: HiSparkles,
    items: [
      "Smart learning with AI",
      "Certified Tutors",
      "All round Educational Excellence",
      "AI Study Companion",
    ],
  },
  {
    id: "curriculum",
    title: "International & National Curriculum",
    Icon: HiBookOpen,
    items: [
      "Cambridge / IGCSE / A & AS Level",
      "NIOS & CBSE",
      "Northwest Accreditation Commission (NWAC), USA",
      "NEP 2020 ( Valid for JEE/NEET/CLAT etc.)",
    ],
  },
  {
    id: "global",
    title: "Global Acceptance",
    Icon: HiGlobeAlt,
    items: [
      "Accepted by Universities in US, UK, Canada, EU, Singapore etc.",
      "Study Abroad Ready",
      "Application Support",
      "Scholarship Guidance",
    ],
  },
];

function PillarCard({ title, Icon, items }) {
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-white/90 p-6 shadow-[0_1px_0_0_rgba(59,43,131,0.06),0_18px_44px_-16px_rgba(30,22,51,0.18)] ring-1 ring-brand/8 backdrop-blur-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_1px_0_0_rgba(59,43,131,0.08),0_24px_56px_-18px_rgba(59,43,131,0.22)] hover:ring-brand/15 sm:p-7">
      <div
        className="pointer-events-none absolute -right-12 -top-12 h-36 w-36 rounded-full bg-gradient-to-br from-brand/[0.09] to-transparent opacity-0 transition duration-500 group-hover:opacity-100"
        aria-hidden
      />
      <div className="relative flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-brand to-brand-dark text-white shadow-md shadow-brand/25">
          <Icon className="h-6 w-6" aria-hidden />
        </span>
        <div className="min-w-0 flex-1 pt-0.5">
          <h3 className="text-lg font-bold leading-snug tracking-tight text-ink sm:text-xl">
            {title}
          </h3>
          <ul className="mt-5 space-y-3 text-pretty text-sm leading-relaxed text-ink/72 sm:text-[0.9375rem]">
            {items.map((item) => (
              <li key={item} className="flex gap-3">
                <HiCheck
                  className="mt-0.5 h-5 w-5 shrink-0 text-brand"
                  aria-hidden
                />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
}

function HomeAltusAdvantage() {
  return (
    <section
      className="relative overflow-hidden bg-gradient-to-b from-brand-light/30 via-brand-light/45 to-brand-light/70 py-16 sm:py-20 lg:py-24"
      aria-labelledby="home-advantage-heading"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-[28rem] w-[min(90vw,52rem)] -translate-x-1/2 rounded-full bg-brand/[0.07] blur-3xl"
        aria-hidden
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <header className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
            Why families choose us
          </p>
          <h2
            id="home-advantage-heading"
            className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl md:text-[2.375rem] md:leading-tight"
          >
            The Altus Advantage
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-pretty text-sm leading-relaxed text-ink/72 sm:mt-6 sm:text-base">
            Personalised pathways, modern learning tools, and qualifications
            that open doors—wherever you go next.
          </p>
        </header>

        <div className="mt-14 grid gap-5 sm:mt-16 sm:grid-cols-2 sm:gap-6 lg:gap-7">
          {pillars.map((pillar) => (
            <PillarCard key={pillar.id} {...pillar} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeAltusAdvantage;
